import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';

export const adalConfig = {
  tenant: '097b08b8-58b4-405c-811c-013d79845539',
  clientId: '209adc2b-875d-4097-80e9-b949f1e40a0c',
  endpoints: {
    api: '209adc2b-875d-4097-80e9-b949f1e40a0c',
  },
  cacheLocation: 'localStorage',
  postLogoutRedirectUri: 'https://reservations.denisonparking.com'
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);

export const getToken = () => {
  return authContext.getCachedToken(authContext.config.clientId);
 };